/**
 * Typed inline selectors for lab catalog taxonomies (OPS-UX-FIX-004).
 */
import {
  InlineSelectorField,
  type InlineSelectorFieldProps } from
'@/modules/lab/catalog/components/InlineSelectorField';
import {
  buildCategorySelectorGroups,
  buildSpecimenSelectorGroups } from
'@/modules/lab/catalog/selectorBuilders';
import { categoryHelperFor } from '@/modules/lab/catalog/quickCreateHelpers';
import { SPECIMEN_HELPER } from '@/modules/lab/catalog/catalogConstants';
import { recordCategoryUse, recordSpecimenUse } from '@/modules/lab/catalog/catalogOperatorPrefs';
import { useMemo } from 'react';

type OmitBuilt = Omit<InlineSelectorFieldProps, 'groups' | 'listLabel'>;

export type CategorySelectorFieldProps = OmitBuilt & {
  prefsVersion?: number;
};

export function CategorySelectorField({ prefsVersion = 0, onChange, ...props }: CategorySelectorFieldProps) {
  const groups = useMemo(() => buildCategorySelectorGroups(), []);
  return (
    <InlineSelectorField
      {...props}
      groups={groups}
      listLabel="Department categories"
      searchPlaceholder="Search departments…"
      emptyLabel="No department — check spelling"
      helperText={props.helperText ?? categoryHelperFor(props.value)}
      onChange={(v) => {
        recordCategoryUse(v);
        onChange(v);
      }} />);


}

export type SpecimenSelectorFieldProps = OmitBuilt & {
  prefsVersion?: number;
};

export function SpecimenSelectorField({ prefsVersion = 0, onChange, value, ...props }: SpecimenSelectorFieldProps) {
  const groups = useMemo(() => buildSpecimenSelectorGroups(), []);
  const helper =
  props.helperText ?? (
  value ? SPECIMEN_HELPER[value] : 'Required — wrong specimen risks rejected samples');
  return (
    <InlineSelectorField
      {...props}
      value={value}
      groups={groups}
      listLabel="Specimen types"
      searchPlaceholder="Search specimen types…"
      emptyLabel="No specimen — check spelling"
      helperText={helper}
      onChange={(v) => {
        recordSpecimenUse(v);
        onChange(v);
      }} />);


}